module.exports = __webpack_public_path__ + "img/icon-tick.064a3c30.svg";